_getMenuDataThunk